import { render } from "./PaymentProduct.vue?vue&type=template&id=1f9fb517"
import script from "./PaymentProduct.vue?vue&type=script&lang=js"
export * from "./PaymentProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__